<template>
  <div v-if="!!quoteId">
    <a v-if="triggerType === 'link'" @click="showModal = true">
      {{ i18n.t('/FinancialOverview/Button Text') }}
    </a>
    <app-button
      v-else
      data-qa="open-financial-overview-modal-button"
      button-type="submit"
      @click="showModal = true"
    >
      {{ i18n.t('/FinancialOverview/Button Text') }}
    </app-button>

    <modal
      v-if="showModal"
      :title="i18n.t('/FinancialOverview/Modal Title')"
      max-width="60%"
      class="financial-overview"
      @close="showModal = false"
    >
      <financial-overview />
    </modal>
  </div>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import Modal from '@/components/generic/presentational/molecules/modal/Modal.vue'
import FinancialOverview from '@/components/generic/presentational/organisms/financialOverview/FinancialOverview.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    AppButton,
    Modal,
    FinancialOverview,
  },
  props: {
    triggerType: {
      type: String,
      default: 'button',
      validator: function (value) {
        // The value must match one of these strings
        return ['button', 'link'].includes(value)
      },
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showModal: false,
    }
  },
  computed: {
    ...mapGetters({
      quoteId: 'quote/quoteId',
    }),
  },
}
</script>

<style></style>
